module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Kilchberg_BL-9293fab27f3122c9acbc5ecd9e72c372.svg";